export default __webpack_public_path__ + "static/share-1a763cf82d54d29a9f63579ed0353c44.jpg";